import { useBrandAssets } from "@ifa/ui";

import styles from "./ZuuModeSwitch.module.css";
import { getZuuModeSwitchLabels, type ZuuDisplayMode } from "./zuuPresentation.js";

type ZuuModeSwitchProps = {
  mode: ZuuDisplayMode;
  onToggle: () => void;
  bottomOffset?: number;
};

export function ZuuModeSwitch({ mode, onToggle, bottomOffset = 24 }: ZuuModeSwitchProps) {
  const labels = getZuuModeSwitchLabels(mode);
  const brandAssets = useBrandAssets();

  return (
    <button
      type="button"
      className={styles.fab}
      aria-label={labels.ariaLabel}
      title={labels.expandedLabel}
      onClick={onToggle}
      style={{ ["--zuu-switch-bottom" as string]: `${bottomOffset}px` }}
    >
      {brandAssets.solidLogo ? (
        <span className={styles.logoBadge}>
          <img src={brandAssets.solidLogo} alt="ZUU" className={styles.logoImage} />
        </span>
      ) : null}
      <span className={styles.textGroup}>
        <span className={styles.collapsedLabel}>模式切換</span>
        <span className={styles.expandedLabel}>{labels.expandedLabel}</span>
      </span>
    </button>
  );
}
